import axiosInstance from './axiosInstance';

const getDashboardTransactions = ({ address, currencyNetworkId }) =>
  axiosInstance.get('/internal/admin/blockchain/dashboard', {
    params: { address, crypto_network_id: currencyNetworkId },
  });

export default getDashboardTransactions;
